import { Col, Row } from 'antd';

import { FormCancelButton, FormSaveButton } from 'common/components';
import {
  CREATE_APL_KEY,
  UPDATE_APL_KEY,
} from 'pages/home/ribbon/components/sections/product-apl/hooks';
import { useIsMutating } from '@tanstack/react-query';
import { useGlobalModal } from 'hooks';

const APLModalFooter = ({ isEdit, handleSubmitForm }) => {
  const { closeAllModal } = useGlobalModal();
  const isSubmitLoading = useIsMutating({
    mutationKey: isEdit ? UPDATE_APL_KEY : CREATE_APL_KEY,
  });

  return (
    <Row>
      <Col flex={1} style={{ textAlign: 'right' }}>
        <FormCancelButton
          key='cancel'
          onClick={() => closeAllModal()}
          disabled={isSubmitLoading}
        />
        <FormSaveButton
          text={'OK'}
          loading={isSubmitLoading}
          onClick={handleSubmitForm}
        />
      </Col>
    </Row>
  );
};

export default APLModalFooter;
